export default "__VITE_ASSET__DC$ZM1W6__"